import Relay from 'react-relay';
/**
*  Delete locker mutation
*/
export default class DeleteLockerMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      removeLocker
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
        lockerId: this.props.lockerId,
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on removeLockerPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
      }
    `;
  }

  /**
  *  Config
  */
 getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/DeleteLockerMutation.js